import { cn } from '@commenda/utils';

import type { OwnershipSummaryMetric } from './OwnershipSummaryHelper';

const DESKTOP_COLUMN_CLASS_NAMES: Record<number, string> = {
  1: 'sm:grid-cols-1',
  2: 'sm:grid-cols-2',
  3: 'sm:grid-cols-3',
};

interface OwnershipSummaryMetricsProps {
  metrics: OwnershipSummaryMetric[];
}

export const OwnershipSummaryMetrics = ({
  metrics,
}: OwnershipSummaryMetricsProps) => (
  <dl
    className={cn(
      'grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-border-secondary bg-border-secondary',
      DESKTOP_COLUMN_CLASS_NAMES[metrics.length] ?? 'sm:grid-cols-4'
    )}
  >
    {metrics.map((metric) => (
      <div
        key={metric.label}
        className="flex flex-col gap-xxs bg-bg-primary px-lg py-md"
      >
        <dt className="txt-extra-small-medium text-text-tertiary">
          {metric.label}
        </dt>
        <dd className="txt-medium-bold break-words text-text-primary">
          {metric.value}
        </dd>
        {metric.caption ? (
          <dd className="txt-extra-small-regular text-text-quaternary">
            {metric.caption}
          </dd>
        ) : null}
      </div>
    ))}
  </dl>
);
